import React from 'react';
import {
  TableBody,
  TableRow,
} from '@material-ui/core';
import TypeCell from './TypeCell';

const Selectable = ({ checked = false, selectable = false, onRowSelected = () => { } }) => {
  if (!selectable) {
    return null;
  }

  const handleOnChange = (event) => onRowSelected(event.target.checked);

  return (
    <TypeCell item={{ type: 'checkbox' }} checked={checked} onClick={handleOnChange} />
  );
};

const TBody = ({
  filteredList = [], onRowSelected = () => { },
}) => {
  const renderCols = (cells) => cells.map((cell, index) => <TypeCell key={`cell${index}`} item={cell} index={index} />);

  return (
    <TableBody>
      {filteredList.map((rowData, index) => {
        const { row = {}, cells = [], item = {} } = rowData;
        return (
          <TableRow key={`cell${index}`}>
            <Selectable
              selectable={row.selectable || false}
              checked={row.checked}
              onRowSelected={(checked) => onRowSelected(item, checked)}
            />
            {renderCols(cells)}
          </TableRow>
        );
      })}
    </TableBody>
  );
};

export default TBody;
